import { useCallback, useEffect, useState } from 'react';
import { userService } from '../services/userService';

export default function useUserProfileFilterOptions(organisationId = '') {
  const [profileOptions, setProfileOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadProfiles = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await userService.getProfileList({
        page: 0,
        limit: 100,
        organisation_id: organisationId || '',
      });
      if (res?.status === 200) {
        setProfileOptions(res?.data?.list || []);
      } else {
        setProfileOptions([]);
      }
    } catch {
      setProfileOptions([]);
    } finally {
      setIsLoading(false);
    }
  }, [organisationId]);

  useEffect(() => {
    loadProfiles();
  }, [loadProfiles]);

  return {
    profileOptions,
    isLoading,
    reload: loadProfiles,
  };
}
